export default {
    apiKey: "AIzaSyBfLSB81fkV0l_CpwYonYen82zC0uvoSxM",
    authDomain: "unaty-prod.firebaseapp.com",
    databaseURL: "https://unaty-prod.firebaseio.com", // https://unaty-prod.firebaseio.com  https://localhost:8080
    projectId: "unaty-prod",
    mapsApiKey: "AIzaSyD4Wvy1vPDvyf8TuqoQI4ds-sYCHEtuBks",
    storageBucket: "unaty-prod.appspot.com",
    messagingSenderId: "530713394225",
    appId: "1:530713394225:web:10dc4d60f47ca3fa102910"
};